import * as ResizablePrimitive from "react-resizable-panels"
import "./resizable.css"

export function ResizablePanelGroup({
  className = "",
  ...props
}: ResizablePrimitive.PanelGroupProps) {
  return (
    <ResizablePrimitive.PanelGroup
      className={`resizable-group ${className}`}
      {...props}
    />
  )
}

export function ResizablePanel(
  props: ResizablePrimitive.PanelProps
) {
  return <ResizablePrimitive.Panel {...props} />
}

export function ResizableHandle(
  props: ResizablePrimitive.PanelResizeHandleProps
) {
  return (
    <ResizablePrimitive.PanelResizeHandle
      className="resizable-handle"
      {...props}
    >
      <div className="resizable-handle-bar" />
    </ResizablePrimitive.PanelResizeHandle>
  )
}